import { render } from "./App.vue?vue&type=template&id=237da178"
const script = {}

import "./App.vue?vue&type=style&index=0&id=237da178&lang=scss"
script.render = render

export default script